import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import AuthShell from '../components/auth/AuthShell';
import AuthField from '../components/auth/AuthField';
import AuthAlert from '../components/auth/AuthAlert';
import styles from '../components/auth/authUi.module.css';

const ResetPasswordPage = () => {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    
    try {
      const response = await api.post(`/api/auth/reset-password/${token}`, { password });
      setMessage(response.data.message);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      console.error('Reset password error:', error.response ? error.response.data : error.message);
      
      // Handle network errors
      if (!error.response) {
        setError('Unable to connect to the server. Please check your internet connection and try again.');
        return;
      }
      
      // Handle specific error cases with user-friendly messages
      const errorMessage = error.response?.data?.error || 'An unexpected error occurred. Please try again.';
      const statusCode = error.response?.status;
      
      if (errorMessage.includes('invalid') || errorMessage.includes('expired')) {
        setError('This password reset link is invalid or has expired. Please request a new reset link.');
      } else if (errorMessage.includes('Password must be') || errorMessage.includes('password')) {
        // Handle password validation errors
        setError(errorMessage);
      } else if (statusCode === 500) {
        setError('Our service is temporarily unavailable. Please try again in a few moments.');
      } else if (errorMessage) {
        // Use the error message directly if it's already user-friendly
        setError(errorMessage);
      } else {
        setError('Unable to reset password. Please try again.');
      }
    }
  };

  return (
    <AuthShell
      title="Choose a new password"
      subtitle="Pick something you haven't used elsewhere. You'll be signed in with it from now on."
      footer={
        <>
          Link expired? <Link to="/forgot-password">Request a new one</Link>
        </>
      }
    >
      <AuthAlert tone="success">{message}</AuthAlert>
      <AuthAlert>{error}</AuthAlert>

      <form className={styles.form} onSubmit={handleSubmit}>
        <AuthField
          id="password"
          name="password"
          label="New password"
          type="password"
          placeholder="Enter new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoFocus
          autoComplete="new-password"
          hint="8+ characters, mixed case, and a number."
          minLength="8"
          pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?!.*\s).{8,}$"
          title="Password must be at least 8 characters with uppercase, lowercase, and a number"
        />

        <button type="submit" className={styles.submit}>
          Save new password
        </button>
      </form>
    </AuthShell>
  );
};

export default ResetPasswordPage;
